import { getFragmentData } from "@/__generated__";
import type {
  ClientRemoveVoucherMutation,
  ClientRemoveVoucherMutationVariables,
} from "@/__generated__/graphql";
import {
  ClientRemoveVoucherDocument,
  InvoiceDetailFragmentFragmentDoc,
  InvoicesByFiltersDocument,
} from "@/__generated__/graphql";
import { showToast } from "@/components/ui/toast/show-toast";
import type { InvoiceDetailData } from "@/containers/profile/invoices/invoice-detail/lib";
import { getInvoiceDetailData } from "@/containers/profile/invoices/invoice-detail/lib";
import { ClientInstance } from "@/lib/graphql/apollo";
import { createRequestFactory } from "@/lib/request-factory";

import { useInvoiceDetailStore } from "./invoiceDetail";
import { useAvailableClientVouchersStore } from "./useAvailableClientVouchers";

export const useRemoveVoucherInvoiceStore = createRequestFactory<
  ClientRemoveVoucherMutation,
  InvoiceDetailData,
  ClientRemoveVoucherMutationVariables
>({
  method: "mutation",
  graphqlDocument: ClientRemoveVoucherDocument,
  transformFunction(data) {
    if (!data.clientRemoveVoucher?.invoice) {
      throw new Error("Invoice not found");
    }
    const invoice = getFragmentData(
      InvoiceDetailFragmentFragmentDoc,
      data.clientRemoveVoucher.invoice,
    );
    return getInvoiceDetailData(invoice);
  },
  onFetchSuccess() {
    useInvoiceDetailStore.getState().refetch();
    useAvailableClientVouchersStore.getState().refetch();
    ClientInstance.refetchQueries({ include: [InvoicesByFiltersDocument] });
    showToast({
      title: "Voucher removed successfully",
      type: "success",
    });
  },
});
